<template>
  <div>
      <Loader></Loader>
      <SnackBar :text="snackbarText" :colour="snackbarColor" :model="snackbarModel"></SnackBar>
    <div v-if="lessonNotReady">
      <v-row>
        <v-alert type="warning" class="mx-auto my-15">
          <h3>{{timeRemaing}}!</h3>

          <v-btn @click="goBack()" rounded :color="getThemeColor" dark>Go Back</v-btn>
        </v-alert>
      </v-row>
    </div>
      <div v-else-if="learnerDoesNotBelongToGroup">
      <v-row>
        <v-alert type="warning" class="mx-auto my-15">
          <h3>You Do Not Have Permission To Join This Live Session!</h3>

          <v-btn @click="goBack()" rounded :color="getThemeColor" dark>Go Back</v-btn>
        </v-alert>
      </v-row>
    </div>
    
    <div v-else class="mt-4">
          <DashboardHeader :title="lesson.topic" v-if="isLeadEducator">
            <v-layout row wrap >
          <v-flex xs12 md3>
            <div id="container" style="text-align:center">     
            
            </div>
          </v-flex>
           <v-flex xs12 md8>
          <FreeHandWithFabric></FreeHandWithFabric>
          <video
            width="250"
            height="250"
            class="mr-1"
            id="educator-video"
            style="border-radius:50%"
            autoplay
          ></video>
        </v-flex>
        </v-layout>
          </DashboardHeader>
        
        <v-layout row wrap v-else>
          <v-flex xs12 md12 >
          <div id="video-grid">
            
          </div>
        </v-flex>
        </v-layout>
       
      <div v-if="recordingFinished">
        <v-btn @click="downloadRecordedVideo()" class="ml-8 mb-6" dark fab right bottom color="red">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn
          @click="uploadRecordedVideo()"
          class="ml-2 mb-6"
          dark
          fab
          right
          bottom
          color="primary"
          v-if="false"
        >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </div>
      <v-btn
        :color="getThemeColor"
        dark
        fab
        @click="dialog = !dialog"
        bottom
        right
        absolute
        class="mb-12"
        transition="slide-y-reverse-transition"
      >
        <v-icon>mdi-comment</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" class="mb-15">
        <v-card class="msgDialog mr-2 mb-10">
          <v-card-text>
            <v-textarea
              rows="2"
              :label="isLeadEducator ? 'Answer a question...':'Ask a question...'"
              v-model="message"
            ></v-textarea>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn x-small color="red" @click="dialog = false" rounded dark class="mr-4">
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
              <v-btn x-small color="green" @click="sendMessage()" rounded dark class="mr-4">
                <v-icon x-small>mdi-send</v-icon>
              </v-btn>
            </v-row>
          </v-card-text>

          <v-virtual-scroll :items="messages" height="500" item-height="100">
            <template v-slot:default="props">
              <v-list two-line>
                <v-list-item :key="props.index+Math.random()">
                  <v-list-item-content
                    :class="props.item.user.email == getCurrentUser.email ? 'whatsAppSender':'whatsAppReceiver'"
                  >
                    <div class="mx-4">
                      <v-list-item-title>{{props.item.message}}</v-list-item-title>
                      <small>{{props.item.user.name}} [{{props.item.user.sid}}]</small>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-dialog>

      <v-speed-dial
        class="mr-16 mb-0"
        v-model="fab"
        bottom
        right
        absolute
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="green accent-4" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-account-group</v-icon>
          </v-btn>
        </template>
        <v-btn
          rounded
          dark
          small
          outlined
          v-for="(user,uid) in usersOnline"
          :key="uid+Math.random"
          class="mr-16"
        >
          <v-icon left color="green accent-4" dark>mdi-account-circle</v-icon>
          {{user.name}}
        </v-btn>
      </v-speed-dial>
    </div>
  
  </div>
</template>

<script>
import io from "socket.io-client";
import FreeHandWithFabric from "@/components/CreateSlideParts/FreeHandWithFabric.vue";
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
import SnackBar from "@/components/myLibrary/SnackBar.vue";
import moment from "moment-timezone";
import DashboardHeader from "@/components/DashboardHeader.vue";

export default {
  props: ["lesson"],
  components: { DashboardHeader, FreeHandWithFabric, Loader, SnackBar },
  computed: {
    getEndPoint() {
      return this.$store.getters.getEndPoint;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    isLeadEducator() {
      return this.getCurrentUser.email == this.lesson.lead_educator;
    }
  },

  mounted() {
    //console.log(this.lesson.lesson_group)
    //console.log(this.getCurrentUser)
    this.learnerBelongsToGroup()
    this.getTimeLeft();
    
    this.videoGrid = document.getElementById("video-grid");
    this.educatorTile = document.getElementById("container");
    this.addUserToUsersOnline(this.getCurrentUser.id);

    if (this.isLeadEducator && !this.lessonNotReady) {
    this.educatorVideoElement = document.getElementById("educator-video");
    this.educatorVideoElement.muted = true;

    navigator.mediaDevices
      .getUserMedia({ video: true})
      .then(educatorFaceTime => {
        this.educatorFaceTime = educatorFaceTime;
        this.educatorVideoElement.srcObject = educatorFaceTime;
        this.educatorVideoElement.addEventListener("loadedmetadata", () => {
          this.educatorVideoElement.play();
        });
      });
    }

    this.myPeer = new window.Peer(undefined, {
      host: "express.bitsems.com",
      secure: true,
      path: "/peerjs",
      config: {
        iceServers: [
          { urls: ["stun:turn.bitsems.com:3478"] },
          {
            urls: ["turn:turn.bitsems.com:5349"],
            username: "baron",
            credential: "baRon*3*"
          }
        ]
      }
    });
    //,"iceTransportPolicy":"all","iceCandidatePoolSize":"0"
    this.socket = io(this.getEndPoint);
    this.roomId = 987;

    this.myPeer.on("open", peerId => {
      this.socket.emit("join-room", this.roomId, peerId);
    });

    
    if (this.isLeadEducator && !this.lessonNotReady) {
      try {
        navigator.mediaDevices
          .getDisplayMedia({
            video: true
          })
          .then(async educatorBoardStream => {
            [this.educatorVideoTrack] = educatorBoardStream.getVideoTracks();
            const audioStream = await navigator.mediaDevices.getUserMedia({audio: true}).catch(e => {throw e});
            [this.educatorAudioTrack] = audioStream.getAudioTracks();
            this.educatorBoardStream = new MediaStream([this.educatorVideoTrack, this.educatorAudioTrack])
            
            this.socket.on("user-connected", newUserId => {
              this.shareEducatorStreamWithStudent(newUserId, this.educatorBoardStream);
              this.socket.emit("add-me", this.roomId, this.getCurrentUser.id);
            });
            this.socket.on("add-to-users-online", currentUserId => {
              this.addUserToUsersOnline(currentUserId);
            });

            // this.mediaRecorder = new MediaRecorder(this.educatorBoardStream);
            // this.mediaRecorder.ondataavailable = this.recordVideoChunks;
            // educatorBoardStream.getVideoTracks()[0].onended = this.recordingStopped;

            // this.mediaRecorder.start();
          });
      } catch (error) {
        return error;
      }
    } else {
       try {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
            audio: true
          })
          .then(studentVideoStream => {
            this.studentVideoStream = studentVideoStream;
              this.myPeer.on("call", call => {
              call.answer(studentVideoStream);
              const videoElement = document.createElement("video");
              call.on("stream", otherUserVideo => {
                this.addVideoStream(videoElement, otherUserVideo);
              });
              this.socket.on("user-connected", newUserId => {
                this.peerId = newUserId;
                this.socket.emit("add-me", this.roomId, this.getCurrentUser.id);
              });
              this.socket.on("add-to-users-online", currentUserId => {
                this.addUserToUsersOnline(currentUserId);
              });
            });
            
          });
      } catch (error) {
        return error;
      }

    }

    this.socket.on("message-received", (user, message) => {
      this.messages.unshift({ user, message });
      this.dialog = true;
    });
  },

  data: () => ({
    studentVideoStream:null,
    educatorVideoElement: null,
    educatorBoardStream: null,
    educatorVideoTrack:null,
    educatorAudioTrack:null,
    educatorFaceTime: null,
    mediaRecorder: null,
    lessonNotReady: false,
    learnerDoesNotBelongToGroup: false,
    timeRemaing: null,
    snackbarText: "",
    snackbarColor: "green",
    snackbarModel: false,
    fab: false,
    direction: "top",
    hover: false,
    transition: "slide-y-reverse-transition",
    dialog: false,
    userIds: [],
    roomId: null,
    videoGrid: null,
    educatorTile:null,
    myPeer: null,
    socket: null,
    message: "",
    msgIndices: [],
    usersOnline: [],
    messages: [],
    peerId: null,
    recorder: null,
    recordedChunks: [],
    recordingFinished: false,
    videoBlob: null,
    videoURL: null,
    anchorTag: null
  }),
  methods: {
    stopMediaStream(stream) {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    },
    recordVideoChunks() {
      this.recordedChunks.push(event.data);
    },
    recordingStopped() {
      this.recordingFinished = true;
    },
    downloadRecordedVideo() {
      this.videoBlob = new Blob(this.recordedChunks, { type: "video/webm" });
      this.videoURL = URL.createObjectURL(this.videoBlob);
      this.anchorTag = document.createElement("a");
      this.anchorTag.href = this.videoURL;
      this.anchorTag.download = this.lesson.topic;
      document.body.appendChild(this.anchorTag);
      this.anchorTag.click();
      this.stopMediaStream(this.educatorFaceTime);
      this.stopMediaStream(this.educatorBoardStream);
      document.body.removeChild(this.anchorTag);
    },
    uploadRecordedVideo() {
      this.stopMediaStream(this.educatorFaceTime);
      this.videoBlob = new Blob(this.recordedChunks, { type: "video/webm" });
      const reader = new FileReader();

      reader.onload = () => {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-blob-to-database",
            { data: event.target.result },
            this.getAccessToken
          )
          .then(base64 => {
            this.$store.commit("setLoader", false);
            const vidblob = this.b64toBlob(base64);
            this.educatorVideoElement.src = URL.createObjectURL(vidblob);
          });
      };
      reader.readAsDataURL(this.videoBlob);
    },
    b64toBlob(dataURI) {
      const byteString = atob(dataURI.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: "video/webm" });
    },
    getTimeLeft() {
      const now = moment.tz(new Date(), "Africa/Johannesburg");

      const live = moment.tz(
        this.lesson.lesson_date_time,
        "Africa/Johannesburg"
      );

      if (now.isBefore(live, "minute") && !this.isLeadEducator) {
        this.lessonNotReady = true;
        this.timeRemaing = this.lesson.topic + " Starts " + live.fromNow();
        return false;
      } else if (now.isAfter(live.add(45, "m"))) {
        this.lessonNotReady = true;
        this.timeRemaing = this.lesson.topic + " Closed " + live.fromNow();
        return false;
      } else {
        this.lessonNotReady = false;
      }
    },
    learnerBelongsToGroup(){
      this.$store.commit('setLoader',true)
      axios.postDataWithToken('/auth/get-user-lesson-groups',{userID:this.getCurrentUser.id},this.getAccessToken).then(lessonGroups => {
        const lessonGroupsArr = []
        lessonGroups.forEach(lg => {
          lessonGroupsArr.push(lg.lesson_group)
        })
        if(lessonGroupsArr.includes(this.lesson.lesson_group)){
          this.learnerDoesNotBelongToGroup = false
        }else{
          this.learnerDoesNotBelongToGroup = true
        }
        this.$store.commit('setLoader',false)
      })
      
    },
    goBack() {
      this.$router.back();
    },
    addVideoStream(videoElement, stream) {
      videoElement.muted = false;
      videoElement.srcObject = stream;
      videoElement.muted = false;
      videoElement.autoplay = true;
      videoElement.addEventListener("loadedmetadata", () => {
        videoElement.play();
      });
      this.videoGrid.append(videoElement);
    },
    addStudentVideoToEducatorTile(videoElement, studentStream) {
      videoElement.muted = false;
      videoElement.controls = true;
      videoElement.height = 150;
      videoElement.width = 150;
      videoElement.setAttribute('style','border-radius: 50%;-webkit-border-radius: 50%;-moz-border-radius: 50%;display: block;margin-left:10px;margin-top:7px;margin-bottom:7px;');
      videoElement.srcObject = studentStream;
      videoElement.addEventListener("loadedmetadata", () => {
        videoElement.play();
      });
      this.educatorTile.append(videoElement);
    },
    shareEducatorStreamWithStudent(newStudentID, educatorBoardStream) {
      const call = this.myPeer.call(newStudentID, educatorBoardStream);
      const videoElement = document.createElement("video");
      call.on("stream", studentVideoStream => {
        this.addStudentVideoToEducatorTile(videoElement, studentVideoStream);
        call.on("close", () => {
          videoElement.remove();
        });
      });
    },
    addUserToUsersOnline(newUserId) {
      axios
        .postDataWithToken(
          "/auth/get-user-by-id",
          { userId: newUserId },
          this.getAccessToken
        )
        .then(user => {
          this.usersOnline.push(user);
          if (this.getCurrentUser.id != user.id) {
            this.lunchSnackBar(
              user.name + " has joined now",
              "green accent-4",
              true
            );
          }
        });
    },
    lunchSnackBar(
      snackbarText = "",
      snackbarColor = "green",
      snackbarModel = false
    ) {
      this.snackbarText = snackbarText;
      this.snackbarColor = snackbarColor;
      this.snackbarModel = snackbarModel;
    },
    sendMessage() {
      this.messages.unshift({
        user: this.getCurrentUser,
        message: this.message
      });
      this.socket.emit(
        "message-sent",
        this.getCurrentUser,
        this.message,
        this.roomId
      );
      this.message = "";
    }
  } //end of methods
};
</script>

<style lang="scss" scoped>
#educator-video {
  position: fixed;
  top: 0;
  right: 0;
}
.msgDialog {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 300px;
  height: 450px;
}
.whatsAppReceiver {
  font-family: "Ubuntu-Italic", "Lucida Sans", helvetica;
  background-color: #075e54;
  color: white;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  padding: 4;
}

.whatsAppSender {
  font-family: "Ubuntu-Italic", "Lucida Sans", helvetica;
  background-color: #dcf8c6;
  color: black;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  padding: 4;
}
</style>